import Vue from 'vue';
import Vuex from 'vuex';
import createLogger from 'vuex/dist/logger';
import persistedState from '@/common/persistedState';
import auth from '../common/auth/vuex';
import mobile from '../common/mobile/index';
import userModules from '../modules/user';
import dro from '../modules/dro/vuex';
import rotation from '../modules/randomRotation/vuex';
import bids from '../modules/bids/vuex';
import behavior from '../modules/undesirableBehavior/index';
import appeals from '../modules/appeals/index';
import protocol from '../modules/dashboardParent/vuex';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';
const plugins = [
  persistedState,
];

const store = new Vuex.Store({
  modules: Object.assign({auth, dro, mobile, rotation, behavior, appeals, bids, protocol}, userModules),
  strict: debug,
  plugins: debug ? plugins.concat([createLogger()]) : plugins,
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js